import { combineReducers } from 'redux'
import { GET_A_MENTOR_DATA, GET_SINGLE_MENTOR_DATA ,VIEW_STARTUP_APPLICATION_DATA} from '../../common/constants/actionConstants'


const currentInerventionList = (state = [], action) => {
    switch (action.type) {
   
      case GET_A_MENTOR_DATA:
        return { ...action.payload }
      default:
        return state
    }
  }
  
  const mentorListData = (state = [], action) => {
    switch (action.type) {
      case GET_SINGLE_MENTOR_DATA:
        return { ...action.payload }
      default:
        return state
    }
  }
  const startupListData = (state = [], action) => {
    switch (action.type) {
      case VIEW_STARTUP_APPLICATION_DATA:
        return { ...action.payload }
      default:
        return state
    }
  }
  const GetMentorDataReducer = combineReducers({
    currentInerventionList,
    mentorListData,
    startupListData
  })
  
  export default GetMentorDataReducer
  